import * as Sentry from '@sentry/browser';

const sentryDSN = import.meta.env.VITE_SENTRY_DSN;
const sentryEnvType = import.meta.env.VITE_SENTRY_ENV_TYPE;
const commitHash = import.meta.env.VITE_COMMIT_HASH;

const IGNORE_ERRORS = [
  'Failed to fetch dynamically imported module',
  /Failed to fetch \(.*\)/g,
  /Load failed \(.*\)/g,
  /^API Error 4[0-9][0-9]:/gm,
  'Network Error',
  'error response 458: No such session',
  'IFrame timed out without a response',
  'Token is inactive because it is malformed, expired or otherwise invalid. Token validation failed.',
  'audio input not available',
];

const DENY_URLS = [/maps\.googleapis\.com/i];

if (sentryDSN && sentryEnvType && commitHash) {
  Sentry.init({
    dsn: sentryDSN,
    environment: sentryEnvType,
    ignoreErrors: IGNORE_ERRORS,
    denyUrls: DENY_URLS,
    release: commitHash,
    integrations: [Sentry.browserTracingIntegration()],
  });
}
